import * as React from 'react';
export function Hideable(props) {
    const { children = (React.createElement(React.Fragment, null)), hide = false, } = props;
    if (hide) {
        return (React.createElement(React.Fragment, null));
    }
    return children;
}
//# sourceMappingURL=index.js.map